<div class="dialog-wrapper">
  <button class="close-btn" type="button" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>

  <h2 class="dialog-title">{{ 'fee.edit_emergency_contact' | translate }}</h2>

  <form [formGroup]="form" class="dialog-form">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ 'fee.emergency_contact_name' | translate }}</mat-label>
      <input matInput formControlName="emergencyContactName">
    </mat-form-field>

    <div class="phone-field full-width">
      <div class="phone-field-control" (click)="focusPhoneInput()">
        <input type="tel"
               #phoneInput
               formControlName="emergencyContactPhone"
               class="form-control form-control-lg confirm-password-reduced-placeholder-width form-tel"
               placeholder="77 123456"
               (keyup)="preventDefaultIfNotNumber($event)"
               (keydown)="preventDefaultIfNotNumber($event)"
               (input)="onPhoneInput()"
               (blur)="validatePhoneNumber()"
               [ngClass]="{'has-error': isPhoneVisuallyInvalid || invalidPhoneMessage}"/>
      </div>
      @if (invalidPhoneMessage) {
        <div class="validation">
          <small>{{ invalidPhoneMessage | translate }}</small>
        </div>
      }
    </div>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ 'fee.email' | translate }}</mat-label>
      <input matInput formControlName="emergencyContactEmail" type="email">
      @if (form.get('emergencyContactEmail')?.invalid && form.get('emergencyContactEmail')?.touched) {
        <mat-error>{{ 'fee.validation.invalid_email_format' | translate }}</mat-error>
      }
    </mat-form-field>
  </form>

  <div class="dialog-actions">
    <button type="button" class="btn-cancel" (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn-save" [disabled]="form.invalid || saving" (click)="save()">
      @if (saving) {
        <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
      } @else {
        {{ 'user_card.save' | translate }}
      }
    </button>
  </div>
</div>
